import React from 'react'
import { connect } from 'react-redux'
import SectionActions from '../../Redux/SectionRedux'
import FilesActions from '../../Redux/FilesRedux'
import FileUploader from '../FileUploader'

class UpdateSubsectionPDF extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      form: {
        pdf_file: ''
      },
      file: null,
      uploaded: false
    }
  }

  componentDidMount = () => {
    this.props.resetFile()
  }

  componentWillReceiveProps = (newProps) => {
    if (newProps.files.data) {
      let form = { ...this.state.form }
      form.pdf_file = newProps.files.data.upload[0].filename
      this.setState({ form })
    }
  }

  _fileUploaded = (filename, field) => {
    let form = { ...this.state.form }
    form[field] = filename
    this.setState({ form })
  }

  _submit = (event) => {
    event.preventDefault()
    let uuid = this.props.detail.id
    let form = { ...this.state.form }
    const data = { uuid, form }
    this.props.submit(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 500)
  }

  render () {
    return (
      <div className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Edit Section Banner</h4>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group'>
            <div className='row'>
              <div className='col-3'>
                <label className='control-label'>Current PDF</label>
              </div>
              <div className='col-9'>
                <p><a href={this.props.detail.pdf_url} target='_blank'>{this.props.detail.pdf_file}</a></p>
              </div>
            </div>
          </div>
          <div className='form-group'>
            <div className='row'>
              <div className='col-3'>
                <label className='control-label'>Choose PDF</label>
              </div>
              <div className='col-9'>
                <FileUploader setting={{ type: 'company-disclosure' }} onUploaded={(filename) => this._fileUploaded(filename, 'pdf_file')} />
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' disabled={!this.state.form.pdf_file} className='btn btn-primary'>Save</button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  files: state.files
})

const dispatchToProps = (dispatch) => ({
  upload: (data) => dispatch(FilesActions.filesUploadRequest(data)),
  resetFile: () => dispatch(FilesActions.filesUploadReset()),
  submit: (data) => dispatch(SectionActions.putSubSectionRequest(data))
})

export default connect(stateToProps, dispatchToProps)(UpdateSubsectionPDF)



// WEBPACK FOOTER //
// ./src/Containers/Section/UpdateSubsectionPDF.js